// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `No teams yet. Be the first to enter!`
};

const de_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Noch keine Teams. Seien Sie das erste!`
};

const es_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Aún no hay equipos. ¡Sé el primero en participar!`
};

const fr_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Aucune équipe pour le moment. Soyez la première à participer !`
};

const fi_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Ei joukkueita vielä. Ole ensimmäinen!`
};

const hi_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `अभी तक कोई टीम नहीं। पहले दर्ज करें!`
};

const ja_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `まだチームがありません。最初に参加してください！`
};

const nl_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Nog geen teams. Wees het eerste om mee te doen!`
};

const pt_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Ainda não há equipas. Seja a primeira a participar!`
};

const ro_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Încă nu sunt echipe. Fii prima echipă care participă!`
};

const th_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `ยังไม่มีทีม เป็นทีมแรกที่เข้าร่วม!`
};

const ur_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `ابھی کوئی ٹیم نہیں۔ پہلی ٹیم بنیں جو شامل ہو!`
};

const zh_hant1_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `還沒有團隊。成為第一個參加的團隊！`
};

const da_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Ingen hold endnu. Vær det første til at deltage!`
};

const it_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Nessuna squadra ancora. Sii la prima a partecipare!`
};

const vn_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Chưa có đội nào. Hãy là đội đầu tiên tham gia!`
};

const ko_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `아직 팀이 없습니다. 첫 번째로 참가해보세요!`
};

const tr_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Henüz takım yok. İlk katılan takım ol!`
};

const lv_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Vēl nav komandu. Esi pirmā komanda, kas piedalās!`
};

const ar_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `لا توجد فرق بعد. كن أول فريق يدخل!`
};

const bs_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Nema timova još. Budite prvi tim koji se pridružuje!`
};

const sl_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Še ni ekip. Bodite prva ekipa, ki se pridruži!`
};

const id_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Belum ada tim. Jadilah yang pertama!`
};

const sv_widget_leaderboard_no_teams = /** @type {(inputs: {}) => string} */ () => {
	return `Inga lag än. Var den första att delta!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_no_teams = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_no_teams(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_no_teams", locale)
	if (locale === "en") return en_widget_leaderboard_no_teams(inputs)
	if (locale === "de") return de_widget_leaderboard_no_teams(inputs)
	if (locale === "es") return es_widget_leaderboard_no_teams(inputs)
	if (locale === "fr") return fr_widget_leaderboard_no_teams(inputs)
	if (locale === "fi") return fi_widget_leaderboard_no_teams(inputs)
	if (locale === "hi") return hi_widget_leaderboard_no_teams(inputs)
	if (locale === "ja") return ja_widget_leaderboard_no_teams(inputs)
	if (locale === "nl") return nl_widget_leaderboard_no_teams(inputs)
	if (locale === "pt") return pt_widget_leaderboard_no_teams(inputs)
	if (locale === "ro") return ro_widget_leaderboard_no_teams(inputs)
	if (locale === "th") return th_widget_leaderboard_no_teams(inputs)
	if (locale === "ur") return ur_widget_leaderboard_no_teams(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_no_teams(inputs)
	if (locale === "da") return da_widget_leaderboard_no_teams(inputs)
	if (locale === "it") return it_widget_leaderboard_no_teams(inputs)
	if (locale === "vn") return vn_widget_leaderboard_no_teams(inputs)
	if (locale === "ko") return ko_widget_leaderboard_no_teams(inputs)
	if (locale === "tr") return tr_widget_leaderboard_no_teams(inputs)
	if (locale === "lv") return lv_widget_leaderboard_no_teams(inputs)
	if (locale === "ar") return ar_widget_leaderboard_no_teams(inputs)
	if (locale === "bs") return bs_widget_leaderboard_no_teams(inputs)
	if (locale === "sl") return sl_widget_leaderboard_no_teams(inputs)
	if (locale === "id") return id_widget_leaderboard_no_teams(inputs)
	if (locale === "sv") return sv_widget_leaderboard_no_teams(inputs)
	return "widget_leaderboard_no_teams"
};